export const tableStyles = {
  table: {
    style: {
      //   border: '1px solid #e2e8f0', // light gray outline
      borderRadius: '0.4rem',
      overflow: 'hidden', // ensures radius applies to child elements
      backgroundColor: '#f8fafc', // light gray background for body
    },
  },

  headRow: {
    style: {
      backgroundColor: '#335797',
      minHeight: '52px',
      borderBottomWidth: '1px',
      borderBottomColor: '#166B75',
      borderBottomStyle: 'solid',
    },
  },

  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '6px',
      paddingBottom: '6px',
      '&:first-of-type': {
        paddingLeft: '20px',
      },
      '&:last-of-type': {
        paddingRight: '20px',
      },
      backgroundColor: '#335797', // Primary color
      color: '#ffffff',
      fontSize: '14px',
      letterSpacing: '0.5px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f8fafc', // match body bg
      borderBottom: '1px solid #e2e8f0',
      '&:hover': {
        backgroundColor: '#E8F5F6', // subtle brand tint on hover
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '3px',
      paddingBottom: '3px',
      // fontSize: '14px',
      color: '#374151',
      '&:first-of-type': {
        paddingLeft: '20px',
      },
      '&:last-of-type': {
        paddingRight: '20px',
      },
    },
  },
  expanderRow: {
    style: {
      backgroundColor: '#f8fafc',
      borderBottom: 'none',
    },
  },
  expanderCell: {
    style: {
      padding: '0',
    },
  },
  expanderButton: {
    style: {
      color: '#6b7280',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      transition: 'all 0.2s ease',
      '&:hover': {
        color: '#335797',
        backgroundColor: '#f3f4f6',
      },
      '&:not(:disabled)': {
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    style: {
      backgroundColor: '#f8fafc', // same light gray as body
      borderTop: '1px solid #e2e8f0',
      padding: '16px 20px',
      fontSize: '14px',
      color: '#475569',
      borderBottomLeftRadius: '0.4rem',
      borderBottomRightRadius: '0.4rem',
    },
    pageButtonsStyle: {
      borderRadius: '6px',
      height: '36px',
      width: '36px',
      padding: '0',
      margin: '0 2px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: 'transparent',
      border: '1px solid #e2e8f0',
      color: '#475569',
      '&:hover': {
        backgroundColor: '#E8F5F6',
        borderColor: '#335797',
        color: '#335797',
      },
      '&:focus': {
        outline: '2px solid #335797',
        outlineOffset: '2px',
      },
      '&[aria-current="page"]': {
        backgroundColor: '#335797',
        borderColor: '#335797',
        color: '#ffffff',
      },
    },
  },
};
